jQuery(function ($) {

  // ─── BMI Quiz Handler ────────────────────────────────────────────────────────
  $('#btnBmiQuiz').click(function () {
    var target_weight     = $('#inputTargetWeight').val();
    var user_height       = $('#inputHeight').val();
    var user_weight       = $('#inputWeight').val();
    var user_weight_lbs   = $('#inputWeightLbs').val();
    var target_weight_lbs = $('#inputTargetWeightLbs').val();

    const weightUnit = $('input[name=weightUnit]:checked').val();
    const heightUnit = $('input[name=heightUnit]:checked').val();

    var weight_in_unit = '';
    if      (weightUnit === 'kilogram') { weight_in_unit = 'kg'; }
    else if (weightUnit === 'stone')    { weight_in_unit = 'st'; }
    else if (weightUnit === 'pound')    { weight_in_unit = 'lbs'; }

    var height_in_unit   = '';
    var height_in_inches = '';
    if (heightUnit === 'centimetre') {
      height_in_unit = 'cm';
    } else if (heightUnit === 'feet') {
      height_in_unit   = 'ft';
      height_in_inches = $('#inputHeightInch').val();
    }

    if (height_in_inches !== '' && height_in_inches !== 'undefined') {
      user_height = user_height + '_' + height_in_inches;
    }

    if (user_weight_lbs !== '' && user_weight_lbs !== 'undefined' && weight_in_unit === 'st') {
      user_weight = user_weight + '_' + user_weight_lbs;
    }

    if (target_weight_lbs !== '' && target_weight_lbs !== 'undefined' && weight_in_unit === 'st') {
      target_weight = target_weight + '_' + target_weight_lbs;
    }

    const bmiArray  = [target_weight, user_height, user_weight, weight_in_unit, height_in_unit];
    const myBmiJSON = JSON.stringify(bmiArray);
    localStorage.setItem('bmi_calculator_cookie', myBmiJSON);
  });


  // ─── Diet & Lifestyle Handler ─────────────────────────────────────────────────
  $('#diet_congrates_btn_id').click(function () {
    const checkboxes   = document.querySelectorAll('input[type="checkbox"], input[type="radio"]');
    const checkedValues = [];
    var data = {};

    checkboxes.forEach(function (checkbox) {
      if (checkbox.checked) {
        var question = checkbox.getAttribute('data-question');
        var ans      = checkbox.value;

        if (data[question] === undefined) {
          data[question] = { ans: ans };
        } else {
          data[question] = { ans: data[question].ans + ',' + ans };
        }
      }
    });

    checkedValues.push(data);
    localStorage.setItem('diet_and_life_cookie', JSON.stringify(checkedValues));
  });


  // ─── Medical History Handler ──────────────────────────────────────────────────
  $('#medical_history_btn_last').click(function (event) {
    event.preventDefault();

    const checkboxes    = document.querySelectorAll('input[type="radio"], input[type="checkbox"], input[type="text"]');
    const checkedValues = [];
    var data = {};

    checkboxes.forEach(function (checkbox) {
      var question = checkbox.getAttribute('data-question');

      if (checkbox.type !== 'text') {
        if (checkbox.checked) {
          var ans = checkbox.value;
          if (data[question] === undefined) {
            data[question] = { ans: ans };
          } else {
            data[question] = { ans: data[question].ans + ',' + ans };
          }
        }
      } else {
        if (question !== null && question !== undefined && question !== '') {
          var ans = checkbox.value;
          if (data[question] === undefined) {
            data[question] = { ans: ans };
          } else {
            data[question] = { ans: data[question].ans + ',' + ans };
          }
        }
      }
    });

    checkedValues.push(data);
    localStorage.setItem('medical_history_cookie', JSON.stringify(checkedValues));

    // ✅ Declare urlParams FIRST so every reference below can use it
    const urlParams         = new URLSearchParams(window.location.search);
    const isMaintenanceOn   = urlParams.get('maintenance') === 'true';
    const redirectUrl       = isMaintenanceOn
      ? 'https://gettrim.co.uk/pages/maintenance-plan'
      : 'https://gettrim.co.uk/pages/product';

    // ✅ Read customer ID from body data attribute (set in theme.liquid)
    //    <body data-customer-id="{{ customer.id | default: '' }}">
    const customerId = document.body.dataset.customerId || '';

    var dataToSend = {
      customer_id:            customerId,
      bmi_calculator:         localStorage.getItem('bmi_calculator_cookie'),
      diet_and_life:          localStorage.getItem('diet_and_life_cookie'),
      medical_history:        localStorage.getItem('medical_history_cookie'),
      check_maintenance_plan: urlParams.get('maintenance'),  // ✅ urlParams already defined
    };

    $.ajax({
      type:        'POST',
      url:         'https://performantcode.io/public/demo/gettrim/api.php',
      crossDomain: true,
      data:        dataToSend,
      success: function () {
        window.location.href = redirectUrl;  // ✅ redirectUrl in scope
      },
      error: function () {
        // ✅ redirectUrl is in scope here too (was broken in original)
        window.location.href = redirectUrl;
      },
    });
  });

});